import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_legally_required_wrkrs_representatives_if_any_elected_and_f'

export const dataPointDefinition = {
  retracedId: 'are_legally_required_wrkrs_representatives_if_any_elected_and_f',
  name: "Are legally required workers' representatives (if any) elected and functioning in line with legal requirements?",
  description:
    "This question relates to non-union workers' representatives who are elected by workers under applicable legal requirements, and who are not part of a bipartite committee. Trade unions, bipartite committees, social dialogue mechanisms and OSH committees are covered separately.\r\r\n\r\r\nThese worker representatives perform functions that do not include activities that are recognized as the exclusive prerogative of trade unions in the jurisdiction concerned. \r\r\n\r\r\nConsult applicable legal requirements before answering this question.\r\r\n\r\r\nIf there are no applicable legal requirements (either because there are no laws at all or because the law does not apply to the facility's specific circumstances), answer No applicable legal requirements. If the facility is not complying with legal requirements regarding the election or functioning of workers' representatives, answer No.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-wor-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12640,
  sectionId: '2.2.10.2',
  impactArea: 'Workplace Cooperation',
  impactAreaId: 'WORKPLACE_COOPERATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
